import React from 'react'
import { Container } from 'react-bootstrap'
import AdasReports from '../components/presentations/adasReports'
import { useBreakpoint } from '../hooks'
import Layout from '../layout'

const AdasReportsContainer = () => {
  const { BREAKPOINT, screenBiggerThan } = useBreakpoint()
  const isBiggerThanXL = screenBiggerThan(BREAKPOINT.XL)

  return (
    <Layout>
      <Container fluid={!isBiggerThanXL}>
        <AdasReports />
      </Container>
    </Layout>
  )
}

export default AdasReportsContainer
